import { Injectable } from "@angular/core";
import { SessionService } from "@core/services/session.service";


@Injectable({
  providedIn: "root"
})
export class FeatureManagementService {
  constructor(
    private readonly _sessionService: SessionService
  ) { }

  public getFeatureValue = (slug: string): boolean => this._sessionService.features[slug] ?? false;

  public getEnabledFeatures(): string[] {
    const featureList: Record<string, boolean> = this._sessionService.features;
    return Object.keys(featureList).filter(key => featureList[key]);
  }

  public getEnabledFeatureList(metricList: any): any {
    const featureList: any = this._sessionService.features;
    return {
      optionList: metricList.optionList.filter((metric: any) => {
        if (featureList.hasOwnProperty(metric.slug)) {
          return !!featureList[metric.slug];
        } else {
          return false;
        }
      })
    };
  }
}
